"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var document_definitions_1 = require("../../model/document-definitions");
var document_type_definition_1 = require("../../model/definition/document-type-definition");
var HttpMetaKnowledgeProviderService = /** @class */ (function () {
    function HttpMetaKnowledgeProviderService(applicationPropertiesService) {
        this.applicationPropertiesService = applicationPropertiesService;
    }
    HttpMetaKnowledgeProviderService_1 = HttpMetaKnowledgeProviderService;
    HttpMetaKnowledgeProviderService.parseConfig = function (categoryDefinitions, definition) {
        return categoryDefinitions ? categoryDefinitions[definition] : null;
    };
    HttpMetaKnowledgeProviderService.prototype.getPartyDefinitions = function (rootCategory) {
        return this.getDefinitions(rootCategory, 'Party');
    };
    HttpMetaKnowledgeProviderService.prototype.getPaymentDefinitions = function (rootCategory) {
        return this.getDefinitions(rootCategory, 'Payment');
    };
    HttpMetaKnowledgeProviderService.prototype.getDocumentDefinitions = function (subCategory) {
        return this.loadDocumentConfig().pipe(operators_1.map(function (documentKnowledge) {
            var classDefaultDocumentDefinitions = new document_definitions_1.DocumentDefinitions();
            if (documentKnowledge) {
                var defaultDocumentDefinition = documentKnowledge['default'];
                var documentDefinition = documentKnowledge[subCategory];
                return __assign({}, classDefaultDocumentDefinitions, defaultDocumentDefinition, documentDefinition);
            }
            return classDefaultDocumentDefinitions;
        }));
    };
    HttpMetaKnowledgeProviderService.prototype.getSignedCopyDocumentDefinitions = function (category) {
        return this.loadSignedCopyConfig().pipe(operators_1.map(function (config) {
            return config ? config[category] : undefined;
        }));
    };
    HttpMetaKnowledgeProviderService.prototype.getDefinitions = function (rootCategory, definition) {
        return this.loadConfig().pipe(operators_1.map(function (everyMetaKnowledge) {
            return everyMetaKnowledge ? HttpMetaKnowledgeProviderService_1.parseConfig(everyMetaKnowledge[rootCategory], definition) : null;
        }));
    };
    HttpMetaKnowledgeProviderService.prototype.loadConfig = function () {
        if (!this.metaKnowledgeConfig$) {
            this.metaKnowledgeConfig$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.loadProjectConfigs()).pipe(operators_1.map(function (value) { return value['categoryDefinitions'] ? JSON.parse(value['categoryDefinitions']) : undefined; }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.metaKnowledgeConfig$;
    };
    HttpMetaKnowledgeProviderService.prototype.loadDocumentConfig = function () {
        if (!this.documentMetaKnowledgeConfig$) {
            this.documentMetaKnowledgeConfig$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.loadProjectConfigs()).pipe(operators_1.map(function (value) {
                var config = value['documentStructureDefinition'];
                if (typeof config === 'string') {
                    return JSON.parse(config);
                }
                else if (typeof config === 'object') {
                    return config;
                }
                return undefined;
            }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.documentMetaKnowledgeConfig$;
    };
    HttpMetaKnowledgeProviderService.prototype.loadSignedCopyConfig = function () {
        if (!this.signedCopyMetaKnowledgeConfig$) {
            this.signedCopyMetaKnowledgeConfig$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.loadProjectConfigs()).pipe(operators_1.map(function (value) { return value['signedCopyDefinitions'] ? JSON.parse(value['signedCopyDefinitions']) : undefined; }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.signedCopyMetaKnowledgeConfig$;
    };
    HttpMetaKnowledgeProviderService.prototype.getDocumentTypeDefinition = function (rootCategory) {
        return this.loadDocumentType().pipe(operators_1.map(function (config) {
            var classDefaultDocumentTypeDefinitions = new document_type_definition_1.DocumentTypeDefinition();
            if (config) {
                var documentTypeDefinition = config[rootCategory];
                return __assign({}, classDefaultDocumentTypeDefinitions, documentTypeDefinition);
            }
            return classDefaultDocumentTypeDefinitions;
        }));
    };
    HttpMetaKnowledgeProviderService.prototype.loadDocumentType = function () {
        if (!this.documentTypeMetaKnowledgeConfig$) {
            this.documentTypeMetaKnowledgeConfig$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.loadProjectConfigs()).pipe(operators_1.map(function (value) { return value['documentTypeDefinitions'] ? JSON.parse(value['documentTypeDefinitions']) : undefined; }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return this.documentTypeMetaKnowledgeConfig$;
    };
    var HttpMetaKnowledgeProviderService_1;
    HttpMetaKnowledgeProviderService = HttpMetaKnowledgeProviderService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpMetaKnowledgeProviderService);
    return HttpMetaKnowledgeProviderService;
}());
exports.HttpMetaKnowledgeProviderService = HttpMetaKnowledgeProviderService;
//# sourceMappingURL=http-meta-knowledge-provider.service.js.map